import { isBoolean, includes, last } from "lodash"

const idToDom = id => id.replace(/\//g, "-")
class Op extends Component {
  render() {
    const {
      nodeProps: {
        isActive,
        onClick = () => {},
        onMouseEnter = () => {},
        onMouseLeave = () => {},
        allowHoverNodes,
      },
      tfName,
      name,
      offset,
      translateX,
      translateY,
      data,
    } = this.props

    const id = tfName ? tfName : name || offset.join("-")
    const nodeDesc = { id }

    const active = isActive ? isActive(nodeDesc) : null
    const baseProps = {
      key: id,
      onClick: () => {
        onClick(nodeDesc)
      },
      onMouseEnter: e => {
        e.stopPropagation()
        onMouseEnter(nodeDesc, e)
      },
      onMouseLeave: e => onMouseLeave(nodeDesc, e),
      ...(isBoolean(active)
        ? {
            style: {
              ...this.styles.node,
              transition: "all 200ms ease-in",
              stroke: active ? "rgba(33,153,209,1)" : "rgba(33,153,209,0)",
              // opacity: active ? 1 : 0.5,
            },
            strokeWidth: 2,
          }
        : this.styles.node),
    }

    if (tfName) {
      // copy obj
      const gProps = Object.assign({}, baseProps, {
        pointerEvents: allowHoverNodes ? "none" : "all",
      })

      // gProps.style.pointerEvents = "none"
      const { width, height } = this.props

      return (
        <g
          {...gProps}
          data-nodeid={tfName}
          transform={`translate(${translateX}, ${translateY})`}
        >
          <rect
            width={width}
            height={height}
            rx={2}
            ry={2}
            style={{
              ...this.styles.background,
              fill: "hsla(213, 80%, 85%, 0.8)",
            }}
          />
        </g>
      )
    }

    const { op } = data

    const transform = {
      transform: `translate(${offset.join(", ")})`,
    }

    const nodeId = idToDom(id)

    const shapes = {
      Relu: (
        <rect
          width={10}
          height={20}
          rx={2}
          data-relu
          data-id={nodeId}
          ry={2}
          {...baseProps}
          {...transform}
        />
      ),
      "MaxPool,AvgPool": (
        <polygon
          points=" 0,0 0,20 3,20 10,12 10,7 3,0 0,0 "
          width={10}
          height={20}
          data-id={nodeId}
          rx={2}
          ry={2}
          {...baseProps}
          {...transform}
        />
      ),
      "Split,Concat,Conv2D,ConcatV2": (
        <rect
          width={10}
          data-id={nodeId}
          height={20}
          rx={2}
          ry={2}
          {...baseProps}
          {...transform}
        />
      ),
      Add: (
        <circle
          data-id={nodeId}
          r={6}
          cx={5}
          cy={10}
          {...baseProps}
          {...transform}
        />
      ),
      MatMul: (
        <rect
          width={10}
          height={40}
          data-id={nodeId}
          rx={2}
          ry={2}
          x={0}
          y={-10}
          {...baseProps}
          {...transform}
        />
      ),
      "Placeholder,Softmax": (
        <polygon
          data-id={nodeId}
          points="0,10 5,20 15,20 20,10 15,0 5,0 0,10"
          {...baseProps}
          {...transform}
        />
      ),
    }

    for (const matches of Object.keys(shapes)) {
      if (includes(matches.split(","), op)) {
        return shapes[matches]
      }
    }

    return null
  }

  styles = {
    bigGroup: {
      fill: "orange",
    },
    background: {
      fill: `hsla(213, 80%, 85%, 1)`,
      opacity: 0.7,
    },
    node: {
      fill: `hsla(213, 80%, 85%, 1)`,
      transition: `all 150ms ease-in`,
      opacity: 0.8,
    },
    active: {
      opacity: 1,
    },
    inactive: {
      opacity: 0.3,
    },
  }
}

class Group extends Component {
  shouldComponentUpdate(props) {
    const { tfName, activeName } = this.props

    if (!activeName) return true

    if (activeName === tfName || props.activeName === tfName) {
      return true
    }

    return false
  }

  render() {
    const { nodeProps, tfName, data, layer = 0 } = this.props

    if (tfName || data.op) return <Op key={tfName} {...this.props} />

    if (data.pathData) {
      return (
        <path
          key={data.pathData}
          style={{
            stroke: `#DDD`,
            strokeWidth: 1.5,
            zIndex: -1,
            fill: "none",
          }}
          d={data.pathData}
        />
      )
    }

    if (data && data.children) {
      return data.children.map((frag, index) => (
        <React.Fragment key={index}>
          <Group
            {...frag}
            key={index}
            nodeProps={nodeProps}
            layer={layer + 1}
          />
        </React.Fragment>
      ))
    }

    return <h2>no data</h2>
  }
}

export default class ModelViewer extends Component {
  render() {
    const {
      data: { fragments },
      isNodeActive,
      onNodeMouseEnter,
      onNodeClick,
      onNodeMouseLeave,
      allowHoverNodes = false,
    } = this.props

    const {
      width = last(fragments.filter(i => i.name)).offset[0] + 30,
    } = this.props

    const nodeProps = {
      isActive: isNodeActive,
      onMouseEnter: onNodeMouseEnter,
      onMouseLeave: onNodeMouseLeave,
      onClick: onNodeClick,
      allowHoverNodes,
    }

    return (
      <svg width={width} height={110}>
        {fragments.map((frag, index) => (
          <Group
            key={index}
            {...frag}
            allowHoverNodes={allowHoverNodes}
            nodeProps={nodeProps}
          />
        ))}
      </svg>
    )
  }
}
